import React from 'react'
import Page from '../components/Page'

const AdminPage = () => {
  return <Page>this is top secret</Page>
}

export default AdminPage
